import { Component, HostListener } from '@angular/core';
import { LangagesService } from 'src/app/services/manage/langages/langages.service';
import { DateAdapter } from '@angular/material/core';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import * as moment from 'moment';
import { ToolsService } from './services/tools/tools.service';
import { borneOrderService } from './services/borneOrder/borneOrder.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})

export class AppComponent {
  title: any;
  isProd = environment.production;
  version = environment.version;
  apiUrl = environment.apiUrl;

  link: HTMLLinkElement | any;
  obserFavicone: any;
  constructor(
    private langServ: LangagesService,
    private adapter: DateAdapter<any>,
    private tools: ToolsService,
    private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private borneOrderService: borneOrderService,
  ) {

    // this.link= document.querySelector('link[rel="icon"]');
    this.link = document.querySelector('#appIcon');

    // Start google analytics tracking
    this.angulartics2GoogleAnalytics.startTracking();

    // Set default lang
    this.langServ.setDefaultFromLocal();

    // Check and set expiry data
    this.tools.checkAndSetExpiryDate();

    // Set lang dynamically
    this.langServ.getCurrLang.subscribe(lang => {

      moment.locale(lang);
      this.adapter.setLocale(lang);
    });

    // Show status message if exist
    this.tools.getStatusMessage.subscribe(statusMessage => {
      if (statusMessage) {
        this.tools.openSnackBar(statusMessage, "great", 5000);
      }
    });

    this.tools.getFavicone().subscribe((data) => {

      this.link.href = data ? 'assets/img/logo/empty.png' : 'assets/img/logo/logo-fulle-xs.png'


    })


  }

  /**
   * @description Listener de scroll
   * @param {any} event
   */
  @HostListener('window:touchstart', ['$event'])
  ontouchstart(event: any) {

    this.borneOrderService.continueOrder("main");

  }





}
